var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHorizontalBar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.25 4.5a.75.75 0 0 0 .75-.75v-1a.75.75 0 0 0-.75-.75H2v2.5h11.25zM7.75 9.25c.467 0 .701 0 .875-.1a.75.75 0 0 0 .275-.275C9 8.701 9 8.467 9 8s0-.701-.1-.875a.75.75 0 0 0-.275-.275c-.174-.1-.408-.1-.875-.1H2v2.5h5.75zM6 13.25a.75.75 0 0 1-.75.75H2v-2.5h3.25a.75.75 0 0 1 .75.75v1z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHorizontalBar);
export default ForwardRef;